(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmd-composite-detail-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-composite-service]').forEach((root) => {
    if (root.dataset.trackingReady) return;
    root.dataset.trackingReady = 'true';
    const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
    const params = new URLSearchParams(location.search);
    const attribution = {};
    keys.forEach((key) => {
      let value = params.get(key) || '';
      try {
        if (value) sessionStorage.setItem('mmd_' + key, value);
        else value = sessionStorage.getItem('mmd_' + key) || '';
      } catch {}
      if (value) attribution[key] = value;
    });
    const publish = (name) => {
      const payload = { service: root.dataset.compositeService, path: location.pathname, ...attribution };
      try { if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish(name, payload); } catch {}
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...payload });
    };
    publish('mmd_composite_landing_view');
    root.querySelectorAll('[data-composite-portal]').forEach((link) => {
      const url = new URL(link.href);
      Object.entries(attribution).forEach(([key, value]) => url.searchParams.set(key, value));
      link.href = url.toString();
      link.addEventListener('click', () => publish('mmd_composite_portal_open'));
    });
    const process = root.querySelector('[data-composite-process]');
    if (process && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          publish('mmd_composite_process_view');
          observer.disconnect();
        }
      }, { threshold: 0.35 });
      observer.observe(process);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmd-product-detail-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mmd-product-detail').forEach((section) => {
      const mainImage = section.querySelector('.mmd-product-detail__main-image');
      const mainMedia = section.querySelector('[data-mmd-product-viewer]');
      const lightbox = section.querySelector('[data-mmd-lightbox]');
      const lightboxImage = section.querySelector('.mmd-product-detail__lightbox-image');
      const openLightbox = section.querySelector('[data-mmd-lightbox-open]');
      const closeLightbox = section.querySelector('[data-mmd-lightbox-close]');
      const prevButton = section.querySelector('[data-mmd-gallery-prev]');
      const nextButton = section.querySelector('[data-mmd-gallery-next]');
      const thumbs = Array.from(section.querySelectorAll('[data-mmd-image]'));
      let activeIndex = 0;
      let touchStartX = 0;

      const isMobileViewer = () => window.matchMedia('(max-width: 749px)').matches;

      const setActiveThumb = (index) => {
        thumbs.forEach((thumb, thumbIndex) => {
          const isActive = thumbIndex === index;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      thumbs.forEach((thumb) => {
        const imageUrl = thumb.getAttribute('data-mmd-image');
        if (imageUrl) {
          const preloadImage = new Image();
          preloadImage.src = imageUrl;
        }
      });

      const showImage = (index) => {
        if (!thumbs.length || !mainImage) return;
        const normalizedIndex = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[normalizedIndex];
        const nextImage = thumb.getAttribute('data-mmd-image');
        const thumbImage = thumb.querySelector('img');

        if (!nextImage) return;
        if (mainImage.currentSrc === nextImage || mainImage.src === nextImage) return;
        activeIndex = normalizedIndex;
        setActiveThumb(activeIndex);

        if (mainMedia) {
          mainMedia.classList.add('is-switching');
        }

        mainImage.srcset = '';
        mainImage.src = nextImage;
        if (thumbImage) {
          mainImage.alt = thumbImage.alt || mainImage.alt;
        }
        if (lightboxImage) {
          lightboxImage.srcset = '';
          lightboxImage.src = nextImage;
        }

        window.requestAnimationFrame(() => {
          if (!mainMedia) return;
          window.setTimeout(() => {
            mainMedia.classList.remove('is-switching');
          }, 80);
        });

        thumb.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          showImage(index);
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', (event) => {
          event.stopPropagation();
          showImage(activeIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', (event) => {
          event.stopPropagation();
          showImage(activeIndex + 1);
        });
      }

      const close = () => {
        if (lightbox) {
          lightbox.hidden = true;
          document.documentElement.classList.remove('mmd-lightbox-open');
        }
      };

      if (openLightbox && lightbox) {
        openLightbox.addEventListener('click', () => {
          if (isMobileViewer() && thumbs.length > 1) {
            showImage(activeIndex + 1);
            return;
          }
          lightbox.hidden = false;
          document.documentElement.classList.add('mmd-lightbox-open');
        });
      }

      if (mainMedia && thumbs.length > 1) {
        mainMedia.addEventListener('touchstart', (event) => {
          touchStartX = event.changedTouches[0]?.clientX || 0;
        }, { passive: true });

        mainMedia.addEventListener('touchend', (event) => {
          const touchEndX = event.changedTouches[0]?.clientX || 0;
          const deltaX = touchEndX - touchStartX;
          if (Math.abs(deltaX) > 38) {
            showImage(activeIndex + (deltaX < 0 ? 1 : -1));
          }
        }, { passive: true });
      }

      if (closeLightbox) {
        closeLightbox.addEventListener('click', close);
      }

      if (lightbox) {
        lightbox.addEventListener('click', (event) => {
          if (event.target === lightbox) {
            close();
          }
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
